import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { buildModel } from './geometry';

const useWarehouseModel = () => {
  const [scene, setScene] = useState(null);
  const [model, setModel] = useState(() => buildModel({}));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.get('/api/v1/warehouse/scene');
      setScene(data);
      setModel(buildModel(data));
    } catch (requestError) {
      setError(requestError.response?.data?.error || requestError.message || 'Unable to load warehouse scene');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { scene, model, loading, error, refresh };
};

export default useWarehouseModel;
